module.exports = __webpack_public_path__ + "static/media/sun_mountain.2dc67091.jpg";